import React from 'react';
import {
  Container,
  Stack,
  Divider,
  Box,
  FormControl,
  Paper,
  Snackbar,
  Button,
  Grid,
  Typography
} from '@mui/material';
import { Autocomplete, Datas, AprovacoesCheckbox } from '../../../components';
import api from '../../../services/api';
import * as yup from 'yup';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import DadosGerais from './DadosGerais';
import { pt } from 'yup-locale-pt';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { CSVDownload } from 'react-csv';
import {
  tagsRel,
  tagsRelFerr,
  tagsRelEco,
  tagsRelEventos,
  tagsRelPremia,
  nivelHierarquico
} from './static';
import { removerQuebrasDeLinha } from '../../../utils/removerQuebraDeLinha';

yup.setLocale(pt);

const Tema09 = () => {
  let startLoading = useStoreActions(actions => actions.nav.startLoading);
  let stopLoading = useStoreActions(actions => actions.nav.stopLoading);
  let user = useStoreState(state => state.auth.user);

  const [empresas, setEmpresas] = React.useState([]);
  const [anoSelecionado, setAnoSelecionado] = React.useState(
    new Date().getFullYear() - 1
  );
  const [openAlerta, setOpenAlerta] = React.useState(0);
  const [csvData, setCsvData] = React.useState([]);
  const [csvDataFerr, setCsvDataFerr] = React.useState([]);
  const [csvDataEco, setCsvDataEco] = React.useState([]);
  const [csvDataEventos, setCsvDataEventos] = React.useState([]);
  const [csvDataPremia, setCsvDataPremia] = React.useState([]);

  const loadEmpresas = async mount => {
    startLoading();
    if (mount.isMounted)
      try {
        let matrizes = (
          await api.http.get(
            '/empresas/' +
              (user.roleId == 'admin' ? '?all=1&matriz=1' : '?matriz=1')
          )
        ).data;
        setEmpresas(matrizes);
        stopLoading();
      } catch (error) {
        stopLoading({
          message: error.toString(),
          severity: 'error'
        });
      }
  };

  const schema = yup
    .object({
      empresa: yup
        .number()
        .positive()
        .label('Selecione a empresa')
        .required()
        .nullable()
    })
    .required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema)
  });

  const { watch } = useFormRef;

  const onChangeAno = (event, item) => {
    setAnoSelecionado(item);
  };

  const empresaId = watch('empresa');

  const handleCloseAlerta = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenAlerta(openAlerta + 1);
  };

  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    loadEmpresas(mount);
    return () => {
      mount.isMounted = false;
    };
  }, []);

  React.useEffect(() => {
    if (empresaId) {
      if (openAlerta == 0) {
        setOpenAlerta(1);
      }
    } else {
      setOpenAlerta(0);
    }
  }, [empresaId]);

  function extrairDataHora(dateTimeStr) {
    const dateObj = new Date(dateTimeStr);
    const year = dateObj.getFullYear().toString();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const day = dateObj.getDate().toString().padStart(2, '0');
    const date = `${day}-${month}-${year}`;
    const hours = dateObj.getHours().toString().padStart(2, '0');
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');
    const seconds = dateObj.getSeconds().toString().padStart(2, '0');
    const time = `${hours}:${minutes}:${seconds}`;
    return date + ' ' + time;
  }
  function converterParaReal(valor) {
    const valorFormatado = valor.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
    return valorFormatado;
  }
  const exportDadosGerais = async () => {
    startLoading();
    try {
      const dados = (await api.http.get('/09/dados-gerais')).data;
      const dadosCsv = dados.map((data, index) => {
        return {
          cnpj: data?.empresa?.cnpj,
          empresa: removerQuebrasDeLinha(data.empresa.nome),
          ano: data.ano,
          fomentoTalento: data?.fomentoTalento ? 'SIM' : 'NÃO',
          intraempreendedor: data?.intraempreendedor ? 'SIM' : 'NÃO',
          intraempreLista: removerQuebrasDeLinha(data?.intraempreLista),
          garantiaIntraemrpre: data?.garantiaIntraemrpre ? 'SIM' : 'NÃO',
          inovacao: data?.inovacao ? 'SIM' : 'NÃO',
          inovacaoLista: removerQuebrasDeLinha(data?.inovacaoLista),
          departInovacao: data?.departInovacao ? 'SIM' : 'NÃO',
          nivelHirarquia: data?.nivelHirarquia
            ? nivelHierarquico[data.nivelHirarquia - 1].label
            : null,
          investimentoInovacao: data?.investimentoInovacao
            ? converterParaReal(data.investimentoInovacao)
            : null,
          investimentoPdtech: data?.investimentoPdtech
            ? converterParaReal(data.investimentoPdtech)
            : null,
          ferramentasInova: data?.ferramentasInova ? 'SIM' : 'NÃO',
          pePocs: data?.pePocs ? 'SIM' : 'NÃO',
          peNumPocs: data?.peNumPocs,
          peHubs: data?.peHubs ? 'SIM' : 'NÃO',
          peListaHubs: removerQuebrasDeLinha(data?.peListaHubs),
          peHackathons: data?.peHackathons ? 'SIM' : 'NÃO',
          peNumHackathons: data?.peNumHackathons,
          ecoInteracStartups: data?.ecoInteracStartups ? 'SIM' : 'NÃO',
          observacoes: data.observacoes
            ? removerQuebrasDeLinha(data.observacoes)
            : null,
          createdAt: data.createdAt ? extrairDataHora(data.createdAt) : null,
          updatedAt: data.updatedAt ? extrairDataHora(data.updatedAt) : null
        };
      });

      if (dadosCsv.length == 0) {
        stopLoading({
          message: 'Nenhum registro encontrado.',
          severity: 'error'
        });
      } else {
        setCsvData([tagsRel, ...dadosCsv]);
        stopLoading();
      }
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };
  const exportDadosFerr = async () => {
    startLoading();
    try {
      const dados = (await api.http.get('/09/ferramentas')).data;
      const dadosCsvFerr = dados.map(data => {
        return {
          cnpj: data?.empresa?.cnpj,
          empresa: removerQuebrasDeLinha(data?.empresa?.nome),
          ano: data?.ano,
          ferramenta: removerQuebrasDeLinha(data?.ferramenta),
          desenvolvimento: removerQuebrasDeLinha(data?.desenvolvimento),
          solucaoPlatafor: removerQuebrasDeLinha(data?.solucaoPlatafor),
          createdAt: data.createdAt ? extrairDataHora(data.createdAt) : null,
          updatedAt: data.updatedAt ? extrairDataHora(data.updatedAt) : null
        };
      });

      if (dadosCsvFerr.length == 0) {
        stopLoading({
          message: 'Nenhum registro encontrado.',
          severity: 'error'
        });
      } else {
        setCsvDataFerr([tagsRelFerr, ...dadosCsvFerr]);
        stopLoading();
      }
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };
  const exportDadosEco = async () => {
    startLoading();
    try {
      const dados = (await api.http.get('/09/ecossistema')).data;
      const dadosCsvEco = dados.map(data => {
        return {
          cnpj: data?.empresa?.cnpj,
          empresa: removerQuebrasDeLinha(data?.empresa?.nome),
          ano: data?.ano,
          nomeStartup: removerQuebrasDeLinha(data?.nomeStartup),
          contatoStartup: data?.contatoStartup,
          emailStartup: data?.emailStartup,
          siteStartup: removerQuebrasDeLinha(data?.siteStartup),
          numTrabFeitos: data?.numTrabFeitos,
          recomendoStartup: data?.recomendoStartup ? 'SIM' : 'NÃO',
          createdAt: data.createdAt ? extrairDataHora(data.createdAt) : null,
          updatedAt: data.updatedAt ? extrairDataHora(data.updatedAt) : null
        };
      });

      if (dadosCsvEco.length == 0) {
        stopLoading({
          message: 'Nenhum registro encontrado.',
          severity: 'error'
        });
      } else {
        setCsvDataEco([tagsRelEco, ...dadosCsvEco]);
        stopLoading();
      }
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };
  const exportDadosEventos = async () => {
    startLoading();
    try {
      const dados = (await api.http.get('/09/eventos')).data;
      const dadosCsvEventos = dados.map(data => {
        return {
          cnpj: data?.empresa?.cnpj,
          empresa: removerQuebrasDeLinha(data?.empresa?.nome),
          ano: data?.ano,
          nomeEvento: removerQuebrasDeLinha(data?.nomeEvento),
          participacao: removerQuebrasDeLinha(data?.participacao),
          createdAt: data.createdAt ? extrairDataHora(data.createdAt) : null,
          updatedAt: data.updatedAt ? extrairDataHora(data.updatedAt) : null
        };
      });

      if (dadosCsvEventos.length == 0) {
        stopLoading({
          message: 'Nenhum registro encontrado.',
          severity: 'error'
        });
      } else {
        setCsvDataEventos([tagsRelEventos, ...dadosCsvEventos]);
        stopLoading();
      }
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };
  const exportDadosPremia = async () => {
    startLoading();
    try {
      const dados = (await api.http.get('/09/premiacoes')).data;
      console.log(dados);
      const dadosCsvPremia = dados.map(data => {
        return {
          cnpj: data?.empresa?.cnpj,
          empresa: removerQuebrasDeLinha(data?.empresa?.nome),
          ano: data?.ano,
          nomePremia: removerQuebrasDeLinha(data?.nomePremia),
          sitePremia: removerQuebrasDeLinha(data?.sitePremia),
          entidadePremia: removerQuebrasDeLinha(data?.entidadePremia),
          createdAt: data.createdAt ? extrairDataHora(data.createdAt) : null,
          updatedAt: data.updatedAt ? extrairDataHora(data.updatedAt) : null
        };
      });

      if (dadosCsvPremia.length == 0) {
        stopLoading({
          message: 'Nenhum registro encontrado.',
          severity: 'error'
        });
      } else {
        setCsvDataPremia([tagsRelPremia, ...dadosCsvPremia]);
        stopLoading();
      }
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  return (
    <Container maxWidth="false">
      <Paper
        variant="outlined"
        className="center-box"
        sx={{
          textAlign: 'center',
          px: 4,
          pt: 2,
          pb: 3,
          m: 5
        }}
      >
        <Grid m={3}>
          <Typography>
            Acesse os seguintes links para referências sobre o preenchimento deste tema:
            <br></br>
            <a
              href="https://ibram.org.br/wp-content/uploads/2024/09/GT-DA-INOVACAO-2.0.pdf"
              target="_blank"
              style={{ fontWeight: 'bold', color: '#004071', marginLeft: 5 }}
              rel="noreferrer"
            >
              (I) E-book GT Inovação;
            </a>
            <br></br>
            <a
              href="https://mininghub.com.br/mh-em-numeros/"
              target="_blank"
              style={{ fontWeight: 'bold', color: '#004071', marginLeft: 5 }}
              rel="noreferrer"
            >
              (II) Números do MiningHub.
            </a>
          </Typography>
        </Grid>
        <Snackbar
          open={Boolean(openAlerta == 1)}
          autoHideDuration={4000}
          onClose={handleCloseAlerta}
        >
          <Alert severity="warning" onClose={handleCloseAlerta}>
            Campos com valores em Reais (R$) devem ser preenchidos com o valor
            completo.
            <br />
            <b>Não utilize a escala de milhões (M) de Reais</b>
          </Alert>
        </Snackbar>
        <Divider>
          <h3>Dados básicos</h3>
        </Divider>
        <Box component="form" autoComplete="off">
          <Stack direction="row" spacing={2}>
            <FormControl fullWidth>
              <Autocomplete
                field="empresa"
                useFormRef={useFormRef}
                options={empresas}
                getOptionLabel={empresa =>
                  empresa.nome + ' (' + empresa.cnpj + ')'
                }
                schema={schema}
              />
            </FormControl>
            <Datas onChange={onChangeAno} value={anoSelecionado} />
          </Stack>
          <Stack direction="row" spacing={2}>
            <AprovacoesCheckbox />
          </Stack>
          {['admin', 'gestor', 'preenchedorSso'].includes(user.roleId) && (
            <Grid container spacing={2} mt={2}>
              <Stack direction="row" spacing={2}>
                <Button
                  variant="contained"
                  onClick={exportDadosGerais}
                  sx={{ height: 45 }}
                >
                  <FileDownloadIcon /> Exportar Dados Gerais (CSV)
                </Button>
                {csvData && csvData.length > 0 && (
                  <CSVDownload
                    data={csvData}
                    headers={tagsRel.headers}
                    separator=";"
                    target="_blank"
                  />
                )}

                <Button
                  variant="contained"
                  onClick={exportDadosFerr}
                  sx={{ height: 45 }}
                >
                  <FileDownloadIcon /> Exportar Dados Ferramentas (CSV)
                </Button>
                {csvDataFerr && csvDataFerr.length > 0 && (
                  <CSVDownload
                    data={csvDataFerr}
                    headers={tagsRelFerr.headers}
                    separator=";"
                    target="_blank"
                  />
                )}
                <Button
                  variant="contained"
                  onClick={exportDadosEco}
                  sx={{ height: 45 }}
                >
                  <FileDownloadIcon /> Exportar Dados Ecossistema (CSV)
                </Button>
                {csvDataEco && csvDataEco.length > 0 && (
                  <CSVDownload
                    data={csvDataEco}
                    headers={tagsRelEco.headers}
                    separator=";"
                    target="_blank"
                  />
                )}
              </Stack>
              <Stack direction="row" spacing={2} mt={1}>
                <Button
                  variant="contained"
                  onClick={exportDadosEventos}
                  sx={{ height: 45 }}
                >
                  <FileDownloadIcon /> Exportar Dados Eventos (CSV)
                </Button>

                {csvDataEventos && csvDataEventos.length > 0 && (
                  <CSVDownload
                    data={csvDataEventos}
                    headers={tagsRelEventos.headers}
                    separator=";"
                    target="_blank"
                  />
                )}

                <Button
                  variant="contained"
                  onClick={exportDadosPremia}
                  sx={{ height: 45 }}
                >
                  <FileDownloadIcon /> Exportar Dados Premiações (CSV)
                </Button>
                {csvDataPremia && csvDataPremia.length > 0 && (
                  <CSVDownload
                    data={csvDataPremia}
                    headers={tagsRelPremia.headers}
                    separator=";"
                    target="_blank"
                  />
                )}
              </Stack>
            </Grid>
          )}
        </Box>
      </Paper>

      {empresaId && (
        <Paper
          variant="outlined"
          className="center-box"
          sx={{
            textAlign: 'center',
            px: 4,
            pt: 2,
            pb: 3,
            m: 5
          }}
        >
          <DadosGerais empresa={empresaId} ano={anoSelecionado} />
        </Paper>
      )}
    </Container>
  );
};

export default Tema09;
